import type { TextColor } from '@ksyos/design-system/dist/components/text';
import { Box, Text } from '@ksyos/design-system';

interface IOutclinicDashboardTableTextBoxProps {
    color?: TextColor;
    label: string;
}

export function OutclinicDashboardTableTextBox(props: IOutclinicDashboardTableTextBoxProps) {
    return (
        <Box
            display="flex"
            justifyContent="center"
            sx={{ 'white-space': 'nowrap' }}
            textAlign="center"
        >
            <Text
                color={props.color ?? 'minimal'}
                fontWeight="medium"
                size="sm"
            >
                {props.label}
            </Text>
        </Box>
    );
}
